export const selectGlobalColor = (state) => state.global.color;
export const selectMainProduct = (state) => state.global.mainProduct;
export const selectPositionTwo = (state) => state.global.positionTwo;
export const selectPositionThree = (state) => state.global.positionThree;
export const selectPositionFour = (state) => state.global.positionFour;
export const selectDrawerStatus = (state) => state.global.drawerStatus